import React from "react"
import DefaultButton from "../../../components/DefaultButton"
import { Plus } from "lucide-react"
import useSearchParamStore from "../../../stores/SearchParamStore"
import { Button } from "@material-ui/core"
import useStyles from "../../styles"

const QueueLayout = () => {
  const classes = useStyles()
  const { setOpenModal } = useSearchParamStore()
  const handleOpenQueueModal = () => {
    setOpenModal(true)
  }

  return (
    <Button
      variant="contained"
      startIcon={<Plus />}
      color="primary"
      className={classes.buttonNova}
      disableElevation
      onClick={handleOpenQueueModal}
    >
      Nova
    </Button>
  )
}

export default QueueLayout
